<template>
  <div class="wscn-http404-container">
    <div class="wscn-http404">
      <img class="pic-404__parent" src="@/assets/images/404.png" alt="404" />
    </div>
    <div class="not-find-descrition">您所访问的页面不存在</div>
  </div>
</template>

<script>
export default {
  name: "Page404",
  computed: {
    message() {
      return "The webmaster said that you can not enter this page...";
    }
  }
};
</script>

<style lang="scss" scoped>
.wscn-http404-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
  text-align: center;
  overflow: hidden;
}
.wscn-http404 {
  width: 200px;
  margin-bottom: 20px;
  .pic-404 {
    float: left;
    width: 100px;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
  }
}
.not-find-descrition {
  font-size: 14px;
}
</style>
